<template>
  <div>
    <v-autocomplete
      v-model="value"
      hide-details
      item-text="data.name"
      item-value="data.id"
      :items="showItems ? items : []"
      :loading="isLoading"
      :no-data-text="noDataText"
      :placeholder="`${$t('search')}..`"
      prepend-inner-icon="search"
      :search-input.sync="searchInput"
      :solo-inverted="inverted"
      :solo="!inverted"
      @change="handleChange($event)"
    />
  </div>
</template>

<script>
import { Server } from '@serversgg/sdk-js'

export default {
  name: 'SearchBox',

  props: {
    inverted: {
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      isLoading: false,
      items: [],
      searchInput: '',
      value: null,
    }
  },

  computed: {
    noDataText () {
      if (this.isLoading) {
        return `${this.$t('loading')}..`
      }

      return this.showItems
        ? 'No servers found.'
        : 'Search for something..'
    },

    showItems () {
      return typeof this.searchInput === 'string' &&
        this.searchInput.length > 1
    },
  },

  watch: {
    async searchInput (newValue) {
      if (
        this.isLoading ||
        !this.showItems
      ) {
        return
      }

      this.isLoading = true

      const servers = await Server.request().fetch({
        language: this.$i18n.locale,
        name: newValue,
      })

      this.items = servers.all()
      this.isLoading = false
    },
  },

  methods: {
    async handleChange (value) {
      await this.$router.push({
        name: 'server.show',
        params: {
          serverId: value,
        },
      })

      this.items = []
      this.value = null
    },
  },
}
</script>
